<form-layout
    [overrideTitle]="'payments' | translate"
    [overrideDescription]="abschnittInfotext"
    [showBack]="false"
    [showNext]="false"
    [showSave]="false"
    [showMobileNavigation]="false"
    >
    <div *ngIf="! payments.length">
        {{ 'payments.no_payments_available' | translate }}!
    </div>
    
    <ng-container *ngComponentOutlet="pendingAmountsComponent, inputs: {
		showFoerdersummeOffen: true
	}"></ng-container>

    <ng-container *ngComponentOutlet="fundingTableComponent, inputs: {
		type: type,
        anfrage: anfrage,
        portalkonfiguration: portalkonfiguration,
        foerdersummeOffen: fundingAmounts.foerdersummeOffen
	}"></ng-container>
</form-layout>